import React, { useState } from 'react';
import { Video } from '@remotion/media';
// Browser Player only. Export has no FillerPreviewContext and retains the
// frame-accurate media decoder, just like ClipPlaybackVideo.
// eslint-disable-next-line no-restricted-imports
import { Video as Html5Video } from 'remotion';
import { useFillerPreviewContext } from './FillerPreviewContext';

export const FillerPlaybackVideo: React.FC<{
  src: string; loop?: boolean; muted?: boolean; playbackRate: number;
  objectFit: 'cover' | 'contain' | 'fill'; style: React.CSSProperties; fallbackSrc?: string;
}> = ({ objectFit, style, fallbackSrc, ...props }) => {
  const previews = useFillerPreviewContext();
  const [failedSource, setFailedSource] = useState<string | null>(null);
  if (previews !== null) {
    const canFallback = !!fallbackSrc && fallbackSrc !== props.src && failedSource !== props.src;
    return <Html5Video {...props} src={failedSource === props.src ? fallbackSrc ?? props.src : props.src}
      onError={canFallback ? () => setFailedSource(props.src) : undefined}
      style={{ ...style, objectFit }} pauseWhenBuffering />;
  }
  return <Video {...props} objectFit={objectFit} style={style} />;
};

